<template>
    <div class="wizard__wrap wizard__wrap--invoices">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>
            <div class="wizard__block-title" style="font-size: 20px">
                Did you issue any new SOWs for {{ getCurrentDealName }}?
            </div>

            <div class="wizard__block-sow">
                <div class="row jus-c--center">
                    <div class="col-lg-12 col-md-12">
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_upsell"
                                id="is_has_new_upsell_yes"
                                :checked="isHasNewUpsell"
                                @change="isHasNewUpsell = true"
                            />
                            <label
                                style="width: 70px"
                                for="is_has_new_upsell_yes"
                                >Yes</label
                            >
                        </div>
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_upsell"
                                id="is_has_new_upsell_no"
                                :checked="isHasNewUpsell === false"
                                @change="isHasNewUpsell = false"
                            />
                            <label
                                style="width: 70px"
                                for="is_has_new_upsell_no"
                                >No</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button @click="onPrevPage" class="btn btn--prev btn--white">
                    Previous
                </button>
                <button @click="onNextPage" class="btn btn--prev btn--white">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { SECTIONS } from "../consts";
import { ignorableWatch } from "@vueuse/core";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Do_You_Have_New_Upsell",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isHasNewUpsell: null,
            isHasNewSow: null,
        };
    },

    mounted() {
        scrollToTop();
    },

    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
        getCurrentDealId() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getSalesPagesIndex
                ).deal.id || null
            );
        },
        getCurrentDealName() {
            return (
                this.$store.getters.getSalesPages(
                    this.$store.getters.getDealSalesIndex
                ).deal_name || null
            );
        },
        sowIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },
        isEditUpsell() {
            return this.$store.getters.getIsEditUpsell;
        },
    },

    methods: {
        onNextPage() {
            if (
                this.isHasNewUpsell === undefined ||
                this.isHasNewUpsell === null
            ) {
                this.$toast.error("Please select an answer");
                return;
            }

            if (this.isEditUpsell) {
                if (this.isHasNewUpsell) {
                    this.onChangeSection(
                        SECTIONS.SOW,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                    return;
                } else {
                    this.onChangeSection(
                        SECTIONS.UPSELL,
                        SECTIONS.DO_YOU_HAVE_UPSELL
                    );
                }
                return;
            }

            if (this.isHasNewUpsell) {
                this.onChangeSection(SECTIONS.SOW, SECTIONS.DO_YOU_HAVE_UPSELL);
                return;
            } else {
                this.onChangeSection(
                    SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW,
                    SECTIONS.DO_YOU_HAVE_UPSELL
                );
            }
        },
        onPrevPage() {
            if (this.isEditUpsell) {
                this.onChangeSection(SECTIONS.FINAL_DASHBOARD);
            } else {
                this.onChangeSection(
                    SECTIONS.EDIT_SALE_LINE_ITEM,
                    SECTIONS.DASHBOARD
                );
            }
        },
    },
};
</script>
